var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('nb-table-dynamic',_vm._b({attrs:{"options":_vm.options},on:{"update:options":function($event){_vm.options=$event},"row-click":_vm.goToCase,"row-right-click":_vm.copyToClipboard,"load-data":_vm.loadData}},'nb-table-dynamic',_vm.tableProps,false))
}
var staticRenderFns = []

export { render, staticRenderFns }